export default Object.freeze({
  Text: 1,
  Number: 2,
  DateTime: 3,
  Date: 4,
  Time: 5,
  Array: 6,
  Object: 7,
});
